module.exports = __webpack_public_path__ + "img/2260@2x.de881c48.png";